// extracted by mini-css-extract-plugin
module.exports = {"basic_info":"permissionControl_basic_info__3X9yz","role_checklist":"permissionControl_role_checklist__13XoK","roleSelects":"permissionControl_roleSelects__39eEk"};